<script>
export default {
    name: "TheatreQueue",

    data() {

        return {
            bookProcedure: false,
            cancelBooking: false,
        };
    },

    components: {
        "book-operation-modal": () => import('./modals/BookOperation.vue'),
        "cancel-booking-modal": () => import('./modals/CancelBooking.vue'),
    },
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                <div class="flex w-full -p-4">
                    <h5 class="font-semibold text-base">Theatre Queue</h5>
                </div>
              </template>
              <template v-slot:card-body>
                  <div class="flex md:flex-row sm:flex-col my-2 bg-gray-400">
                      <div class="md:w-1/6 sm:w-1/4 p-1">
                            <button class="btn-sm btn-warning text-xs" @click.prevent="bookProcedure=true"><i class="fa fa-clipboard"></i> Book Operation</button>
                            <book-operation-modal :showModal="bookProcedure" @closeModal="bookProcedure=false"></book-operation-modal>
                      </div>
                      <div class="md:w-1/6 sm:w-1/4 p-1">
                            <button class="btn-sm btn-danger text-xs" @click.prevent="cancelBooking=true"><i class="fa fa-times"></i> Cancel Booking</button>
                            <cancel-booking-modal :showModal="cancelBooking" @closeModal="cancelBooking=false"></cancel-booking-modal>
                      </div>
                  </div>
                  <div class="w-full overflow-auto max-h-screen">
                        <div class="w-full flex flex-wrap">
                            <div class="md:w-1/4 sm:w-1/4 p-tiny">
                                <input type="text" class="input-sm input-control text-sm" placeholder="Search">
                            </div>
                            <div class="md:w-1/4 sm:w-1/4 p-tiny">
                                <button class="btn-sm btn-primary text-xs"><i class="fa fa-search"></i> Filter</button>
                            </div>
                        </div>
                        <table class="w-full table table-hover">
                            <thead class="bg-indigo-400 text-sm">
                                <tr class="flex text-white w-full">
                                    <th class="p-tiny w-1/4">Patient</th>
                                    <th class="p-tiny w-1/3">Treatment Details</th>
                                    <th class="p-tiny w-1/4">Date</th>
                                    <th class="p-tiny w-1/4">Time</th>
                                    <th class="p-tiny w-1/4">Theatre Room</th>
                                    <th class="p-tiny w-1/4">Procedure Status</th>
                                    <th class="p-tiny w-1/4">Payment Status</th>
                                    <th class="p-tiny w-1/5">Select</th>
                                </tr>
                            </thead>
                            <tbody class="text-xs font-semibold flex flex-col items-center overflow-auto w-full" style="height: 65vh;">
                                <tr class="flex w-full">
                                    <td class="p-tiny w-1/4">
                                        <h5 class="text-sm leading-5 font-medium text-gray-900">Patient Name</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">MRN: </h5>
                                        <h5 class="text-xs leading-5 text-gray-700">DOB: </h5>
                                        <h5 class="text-xs leading-5 text-gray-700">Gender: </h5>
                                    </td>
                                    <td class="p-tiny w-1/4"></td>
                                    <td class="p-tiny w-1/4"></td>
                                    <td class="p-tiny w-1/4"></td>
                                    <td class="p-tiny w-1/4"></td>
                                    <td class="p-tiny w-1/4"></td>
                                    <td class="p-tiny w-1/4"></td>
                                    <td class="p-tiny w-1/6">
                                        <button class="btn-sm text-xs btn-primary"><i class="fa fa-check"></i></button>
                                    </td>
                                </tr>
                                <tr class="flex w-full">
                                    <td class="p-tiny w-1/4">
                                        <h5 class="text-sm leading-5 font-medium text-gray-900">Name Patient</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">MRN: </h5>
                                        <h5 class="text-xs leading-5 text-gray-700">DOB: </h5>
                                        <h5 class="text-xs leading-5 text-gray-700">Gender: </h5>
                                    </td>
                                    <td class="p-tiny w-1/4"></td>
                                    <td class="p-tiny w-1/4"></td>
                                    <td class="p-tiny w-1/4"></td>
                                    <td class="p-tiny w-1/4"></td>
                                    <td class="p-tiny w-1/4"></td>
                                    <td class="p-tiny w-1/4"></td>
                                    <td class="p-tiny w-1/6">
                                        <button class="btn-sm text-xs btn-primary"><i class="fa fa-check"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                  </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>
